/**
 * AMPD DCMS2
 *
 * @copyright AMPD Sp. z o.o. / PTWP-ONLINE Sp. z o.o.
 * @author    Dominik Szmidt
 * @link      https://www.ampd.pl
 * @license   Commercial - usage requires a valid license
 * @see       /doc Documentation directory
 * @see       https://docs.ampd.pl Online documentation and examples
 *
 * Menu breadcrumbs (AMPD\DCMS2\Menus\MenuBreadcrumbs, `.dcms-breadcrumbs`) belong to a page shown as
 * a page — in the main window or in the main content frame (`iframe.iframeContent`). A page opened in
 * any other frame (an iziModal window, e.g. CommandTarget::Modal, or a side panel) hides them: there
 * the trail would lead the whole window away from the page behind the dialog. The server already
 * leaves them out for `datasetPopup=1`, `datasetDrawer=1` and child datasets; this covers the
 * dialogs opened with a plain page URL.
 */

/**
 * Whether this document is the content of a dialog frame (not the main window, not the main content frame).
 *
 * @returns {boolean}
 */
export function isInDialogFrame() {
    let frame = null;
    try {
        frame = window.frameElement;
    } catch (e) {
        // Cross-origin embed — not a DCMS2 dialog
        return false;
    }
    return frame !== null && !frame.classList.contains('iframeContent');
}

function hideBreadcrumbsInDialogFrames() {
    if (!isInDialogFrame()) {
        return;
    }
    document.documentElement.classList.add('dcms-in-dialog-frame');
    document.querySelectorAll('.dcms-breadcrumbs').forEach((nav) => {
        nav.hidden = true;
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideBreadcrumbsInDialogFrames);
} else {
    hideBreadcrumbsInDialogFrames();
}
